var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNavUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 11.2C11.0001 9.26701 12.5671 7.70001 14.5001 7.70001C16.4331 7.70001 18.0001 9.26701 18.0001 11.2C18.0001 13.133 16.4331 14.7 14.5001 14.7C12.5671 14.7 11.0001 13.133 11.0001 11.2ZM14.5001 9.10001C13.3403 9.10001 12.4001 10.0402 12.4001 11.2C12.4001 12.3598 13.3403 13.3 14.5001 13.3C15.6599 13.3 16.6001 12.3598 16.6001 11.2C16.6001 10.0402 15.6599 9.10001 14.5001 9.10001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4668 14C4.4668 8.45875 8.95887 3.96667 14.5001 3.96667C20.0414 3.96667 24.5335 8.45875 24.5335 14C24.5335 19.5413 20.0414 24.0333 14.5001 24.0333C8.95887 24.0333 4.4668 19.5413 4.4668 14ZM14.5001 5.36667C9.73207 5.36667 5.8668 9.23195 5.8668 14C5.8668 16.3759 6.82651 18.5276 8.37943 20.0886C8.5478 19.1804 8.87861 18.324 9.54261 17.6354C10.5358 16.6054 12.124 16.1 14.5001 16.1C16.8762 16.1 18.4643 16.6054 19.4576 17.6354C20.1216 18.3241 20.4524 19.1804 20.6208 20.0887C22.1737 18.5277 23.1335 16.3759 23.1335 14C23.1335 9.23195 19.2682 5.36667 14.5001 5.36667ZM19.3476 21.145C19.2525 20.0139 19.0069 19.185 18.4498 18.6072C17.8436 17.9786 16.7204 17.5 14.5001 17.5C12.2797 17.5 11.1566 17.9786 10.5504 18.6072C9.99331 19.1849 9.7477 20.0139 9.65261 21.145C11.0345 22.0844 12.7032 22.6333 14.5001 22.6333C16.297 22.6333 17.9657 22.0844 19.3476 21.145Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNavUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NavUser.baddae09.svg";
export { ForwardRef as ReactComponent };